<template>
  <div>
    <v-dialog v-model="show" max-width="600px">
      <v-card v-if="deleteConfirm">
        <v-card-title>{{ view.name }}</v-card-title>
        <v-card-text>
          <v-row
            ><v-col
              ><label>Please Confirm Delete</label></v-col
          ></v-row>
        </v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer
          ><v-btn
            @click="saveDefinition(true)"
            >Confirm</v-btn>
          <v-btn @click="cancel">Cancel</v-btn></v-card-actions
        >
      </v-card>
      <v-card v-else>
        <v-card-title>{{ view.isNew ? "Save View As" : "Edit View" }}</v-card-title>
        <v-card-text>
          <v-row
            ><v-col
              ><v-text-field
                v-model="view.name"
                label="View Name"
              ></v-text-field></v-col
          ></v-row>
          <v-row v-if="(!permissions || permissions.saveViewOwn) 
              && (view.isNew || view.restricted || currentView.restricted)"
            ><v-col
              ><v-checkbox
                :disabled="
                  permissions &&
                  permissions.saveViewOwn &&
                  !permissions.saveViewMain
                "
                v-model="view.restricted"
                label="Visible to me only? (Will appear under 'My Views')"
              ></v-checkbox></v-col
          ></v-row>
        </v-card-text>
        <v-card-actions
          ><v-btn v-if="!view.isNew"
            @click="saveDefinition(true)"
            >Delete</v-btn
          ><v-spacer></v-spacer
          ><v-btn
            @click="saveDefinition()"
            :disabled="!view.name || !view.name.trim()"
            >Save</v-btn
          >
          <v-btn @click="cancel">Cancel</v-btn></v-card-actions
        >
      </v-card>
    </v-dialog>
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
    <Loading :isVisible="isLoading" />
  </div>
</template>

<script>
import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
import { mapState } from "vuex";

export default {
  name: "saveViewDefinition",
  components: {
    ResponseHandler,
  },
  props: {
    saveTrigger: { type: Number, required: false, default: 0 },
    saveAsTrigger: { type: Number, required: false, default: 0 },
    inactiveTrigger: { type: Number, required: false, default: 0 },
    editTrigger: { type: Number, required: false, default: 0 },
    currentView: { type: Object, required: false },
    page: { type: String, required: true },
    permissions: { type: Object, required: false },
  },
  data: function () {
    return {
      show: false,
      deleteConfirm: false,
      view: {
        name: "",
        view_type: this.page,
        active: true,
        view_definition_id: 0,
        definition: null,
        description: "",
        restricted: true,
        isNew: false,
      },
      response: null,
    };
  },
  watch: {
    saveTrigger(val) {
      if (val > 0) {
        this.prepView();
        this.saveDefinition();
      }
    },
    inactiveTrigger(val) {
      if (val > 0) {
        this.prepView(true);
        this.show = true;
      }
    },
    saveAsTrigger(val) {
      if (val > 0) {
        this.prepView();
        this.saveDefinitionAs();
      }
    },
    editTrigger(val) {
      if (val > 0) {
        this.prepView();
        this.editDefinition();
      }
    },
    isLoading(val) {
      if (!val) this.fetchData();
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.docs.loading,
    }),
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.isLoading) return;
      this.$store
        .dispatch("settings/getViewDefinitions", this.page)
        .then((resp) => {
          this.$emit("viewsLoaded", resp.data.Data);
        }),
        (error) => {
          console.error(error);
        };
    },
    prepView(deleteConfirm) {
      this.view = { ...this.view, ...this.currentView };
      this.deleteConfirm = !!deleteConfirm;
    },
    saveDefinitionAs() {
      this.show = true;
      this.view.isNew = true;
      this.view.restricted = true;
    },
    editDefinition() {
      this.show = true;
      this.view.isNew = false;
    },
    setViewTitle(view) {
      view.title = view.name + (view.restricted ? " (My view)" : "");
    },
    cancel() {
      this.show = false;
      this.$emit("cancel");
    },
    saveDefinition(makeInactive) {
      let possibleError = false;
      let view = this.view;
      view.active = makeInactive ? false : true;
      view.view_definition_id =
        view.isNew && !makeInactive
          ? null
          : this.currentView.view_definition_id;
      view.name = view.name.trim();
      view.definition = this.currentView.definition;
      view.description = this.currentView.description;
      this.setViewTitle(view);
      axios
        .post("user/saveViewDefinition/", view)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            if (resp.data.Data) {
              if (resp.data.Data.isDuplicateName) {
                if (resp.data.Data.newName === this.currentView.name) {
                  resp.data.Message = "Name already exists. Plese choose another name";
                  this.response = resp.data;
                  return;
                } else {
                  resp.data.Message =
                    `Name already exists. View saved as '${resp.data.Data.newName}'`;
                  view.name = resp.data.Data.newName;
                }
              } 
              if (view.isNew) {
                view = JSON.parse(JSON.stringify(view));
              }
              if (!view.view_definition_id) {
                view.view_definition_id =
                  resp.data.Data.view.view_definition_id;
              }
              if (view.isNew) {
                view.isNew = false;
                this.$emit("viewAdded", view);
              } else {
                if (makeInactive) {
                  resp.data.Message = "View removed.";
                  this.$emit("viewInactive", view);
                } else {
                  this.$emit("viewSaved", view);
                }
              }
              this.show = false;
            }
          }
          this.response = resp.data;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/vars";
</style>
